import React, {
  FunctionComponent,
  ReactElement,
  useRef,
  useState,
} from 'react';
import classNames from 'classnames';

import { useIsOnScreen } from '@hooks/useIsOnScreen';

import { lazy, tracer } from './styles.module.css';

type WithLazyBackgroundImageProps = {
  // Limit children to a single child element
  children: ReactElement;
};

const WithLazyBackgroundImage: FunctionComponent<WithLazyBackgroundImageProps> = ({
  children,
}): JSX.Element => {
  // Limited to one child, rename for clarity
  const child = children;

  const ref = useRef(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const childWithLazyAttributes = (
    originalChild: ReactElement,
  ): ReactElement => {
    const lazyClass = isLoaded ? false : lazy;
    const className = classNames(originalChild.props.className, lazyClass);
    const props = {
      className,
    };

    const newChild = React.cloneElement(originalChild, props);
    return newChild;
  };

  useIsOnScreen({
    ref,
    onView: () => {
      setIsLoaded(true);
    },
  });

  // We can't apply the ref (needed to track when the child comes on screen)
  // to the child element directly, so we add a sibling element to the DOM that
  // keeps itself out of the way as a location tracer to the child we care about
  return (
    <>
      <span ref={ref} className={tracer}></span>
      {childWithLazyAttributes(child)}
    </>
  );
};

export default WithLazyBackgroundImage;
